import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { faUtensils } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CARD_BORDER_RADIUS } from "./Product"

type StyleProps = Readonly<{
    isLarge: boolean
}>

const useStyles = makeStyles<StyleProps>()((theme, { isLarge }) => ({
    wrap: {
        width: "100%",
        height: isLarge ? "18rem" : "8.75rem",
        borderTopLeftRadius: isLarge ? 0 : CARD_BORDER_RADIUS,
        borderTopRightRadius: isLarge ? 0 : CARD_BORDER_RADIUS,
        overflow: "hidden",
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    placeholder: {
        width: "100%",
        height: "100%",
        padding: "1rem",
        color: theme.palette.grey[500],
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.tailwind.slate[200],
    },
}))

type ProductImgProps = Readonly<{
    imageUrl?: string
    size?: "small" | "large"
}>

const ProductImg = ({ imageUrl, size = "small" }: ProductImgProps) => {
    const { classes } = useStyles({ isLarge: size === "large" })

    return (
        <Box className={classes.wrap}>
            {!Boolean(imageUrl) ? (
                <Box className={classes.placeholder}>
                    <FontAwesomeIcon size="4x" icon={faUtensils} />
                </Box>
            ) : (
                <img src={imageUrl} className={classes.image} />
            )}
        </Box>
    )
}

export default ProductImg
